import React from "react";

export default function Demographics() {
  // Data Arrays
  const attendeeJobProfiles = [
    { title: "Government Executive", percent: 15, color: "#e94b6e" },
    { title: "Top Management & Leadership", percent: 25, color: "#4353ff" },
    { title: "Project Director, Head of Technical Dept", percent: 42, color: "#28a745" },
    { title: "BD, Sales & Marketing", percent: 16, color: "#845ec2" },
    { title: "Leading Technical Specialist", percent: 2, color: "#555" },
  ];

  const internationalAttendance = [
    { title: "North America", percent: 43, color: "#28a745" },
    { title: "Europe", percent: 22, color: "#4353ff" },
    { title: "Middle East", percent: 16, color: "#845ec2" },
    { title: "Asia Pacific", percent: 12, color: "#e94b6e" },
    { title: "Others", percent: 7, color: "#555" },
  ];

  const attendingCompanies = [
    { title: "Oil Companies", percent: 32, color: "#28a745" },
    { title: "Refineries & Petrochemical Plants", percent: 20, color: "#e94b6e" },
    { title: "EPC", percent: 21, color: "#845ec2" },
    { title: "Service Companies", percent: 23, color: "#4353ff" },
    { title: "Research Institutes", percent: 4, color: "#555" },
  ];

  // Card component for repeated structure
  const DemographicCard = ({ title, data }) => (
    <div className="col-lg-4 col-md-6 mb-4">
      <div
        style={{
          backgroundColor: "#fdfdfd",
          border: "1px solid #e3e3e3",
          borderRadius: "10px",
          padding: "25px",
          height: "100%",
          boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
        }}
      >
        <h5
          style={{
            fontWeight: "700",
            fontSize: "1.1rem",
            color: "#003c4d",
            marginBottom: "25px",
          }}
        >
          {title}
        </h5>
        {data.map((item, i) => (
          <div key={i} style={{ marginBottom: "18px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "0.9rem",
                marginBottom: "6px",
              }}
            >
              <span>{item.title}</span>
              <span>({item.percent}%)</span>
            </div>
            <div
              style={{
                width: "100%",
                height: "8px",
                background: "#e9ecef",
                borderRadius: "10px",
                position: "relative",
              }}
            >
              <div
                style={{
                  width: `${item.percent}%`,
                  height: "100%",
                  background: item.color,
                  borderRadius: "10px",
                }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <section style={{ padding: "80px 0", backgroundColor: "#fff" }}>
      <div className="container">
        <div className="text-center mb-5">
          <h2
            style={{
              fontWeight: "800",
              fontSize: "2.4rem",
              marginBottom: "20px",
            }}
          >
            Demographics of Attendees
          </h2>
          <p
            style={{
              fontSize: "1rem",
              lineHeight: "1.8",
              color: "#444",
              maxWidth: "900px",
              margin: "0 auto",
            }}
          >
            Through our platform, you will have the opportunity to connect with all job
            levels of professionals in the industry. This means that you can discover
            new solutions, innovative technology, market outlooks and insight into
            consumer trends from various external perspectives.
          </p>
          <p
            style={{
              fontSize: "1rem",
              lineHeight: "1.8",
              color: "#444",
              maxWidth: "900px",
              margin: "20px auto 0",
            }}
          >
            Take part in 1-to-1 meetings with potential leads and showcase your solutions
            in front of industry leaders. Find empowered buyers and/or decision-makers
            from across the globe all in one place.
          </p>
        </div>

        <div className="row">
          <DemographicCard
            title="ATTENDEE JOB PROFILES (%)"
            data={attendeeJobProfiles}
          />
          <DemographicCard
            title="INTERNATIONAL ATTENDANCE (%)"
            data={internationalAttendance}
          />
          <DemographicCard
            title="ATTENDING COMPANIES (%)"
            data={attendingCompanies}
          />
        </div>
      </div>
    </section>
  );
}
